/* eslint-disable jsx-a11y/label-has-for */
import React, { PropTypes } from 'react';
import Input from 'react-toolbox/lib/input';
import Switch from 'react-toolbox/lib/switch';

export function renderError(input, err, touched) {
  if (err && touched) {
    const htmlFor = input.name;
    return <label htmlFor={htmlFor}>{err}</label>;
  }
  return null;
}

export const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => {
  return (
    <Input
      label={label}
      value={input.value}
      error={renderError(input, error, touched)}
      {...input}
      {...custom}
    />
  );
};

renderTextField.propTypes = {
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
};

export const renderSwitchListItemField = ({
  input,
  checked,
  data,
  meta,
  ...custom
}) => {
  return <Switch name={input.name} checked={checked} {...input} {...custom} />;
};

renderSwitchListItemField.propTypes = {
  input: PropTypes.object,
  checked: PropTypes.bool,
  data: PropTypes.object,
  meta: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/client/src/utils/formUtils.js